// extracted by mini-css-extract-plugin
export default {"toggle":"themeToggle_toggle__IsyYY","icon":"themeToggle_icon__a5CO0"};